import type { ButtonHTMLAttributes, Ref } from "react";
import { cn } from "@/lib/utils";
import { FOCUS_RING } from "./focusRing.constants";
export function Pressable({
  type,
  className,
  ref,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  ref?: Ref<HTMLButtonElement>;
}) {
  return <button ref={ref} type={type ?? "button"} className={cn(FOCUS_RING, className)} {...props} data-sentry-component="Pressable" data-sentry-source-file="Pressable.tsx" />;
}